export enum Language {
    ENGLISH = "English",
    SPANISH = "Spanish",
    OTHER = "Other"
}